export const siteInfo = {
  name: '健康娱乐指南',
  fullName: '茄子视频污内容风险警示与健康娱乐替代指南',
  tagline: '远离不良内容，拥抱健康娱乐',
  description: '揭示茄子视频污等不良视频的法律风险、平台封禁原因及对青少年的危害，推荐合规、健康的正规短视频娱乐平台，帮助用户安全享受优质内容。',
  url: 'https://jiankangyule.com',
  email: 'contact@jiankangyule.com',
  phone: '400-123-4567',
  address: '北京市朝阳区网络安全产业园A座',
  foundedYear: 2024,
  mission: '致力于推动中国网络空间清朗化，通过内容教育、风险警示和平台推荐，帮助亿万网民远离不良内容，拥抱健康、合规的数字娱乐生活。',
  socialLinks: {
    weibo: 'https://weibo.com/jiankangyule',
    wechat: 'jiankangyule',
    douyin: 'https://douyin.com/@jiankangyule',
  },
};

export const navItems = [
  { label: '首页', href: '/' },
  { label: '风险警示', href: '/category/risk-warning' },
  { label: '健康替代', href: '/category/healthy-alternative' },
  { label: '法律合规', href: '/category/legal-compliance' },
  { label: '青少年保护', href: '/category/youth-protection' },
  { label: '关于我们', href: '/about' },
];